export const POST_COMPLAIN_BEGIN = "POST_COMPLAIN_BEGIN";
export const POST_COMPLAIN_SUCCESS = "POST_COMPLAIN_SUCCESS";
export const POST_COMPLAIN_ERROR = "POST_COMPLAIN_ERROR";

export const GET_COMPLAIN_BEGIN = "GET_COMPLAIN_BEGIN";
export const GET_COMPLAIN_SUCCESS = "GET_COMPLAIN_SUCCESS";
export const GET_COMPLAIN_ERROR = "GET_COMPLAIN_ERROR";
